class MainProductColor extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.options = qsa(".option-value", this);
    this.parent = qs(".product-template-wrapper");
    this.clickEvent();
    this.swatchToggle()
  };

   swatchToggle = () => {
    let swatches = document.querySelectorAll(
      ".product-section-overview .color-swatch-wrapper .shades-wrapper-items .option-value"
    );
    let btn = document.querySelector(
      ".product-section-overview .color-swatch-wrapper .shades-wrapper-items .more-btn"
    );
  
    if (btn) {
      btn.addEventListener("click", () => {
        if (btn.innerText.toLowerCase() === "+") {
          swatches.forEach((ele, i) => {
              ele.classList.remove("d-none"); // Show hidden swatches
          });
          btn.innerText = "-"; // Change button text to "less"
        } else {
          swatches.forEach((ele, i) => {
            if (i > 9 && !ele.classList.contains("active")) {
              ele.classList.add("d-none"); // Hide non-active swatches
            }
          });
          btn.innerText = "+"; // Change button text back to "more"
        }
      });
    }
  };
  
 
  

  getHtml = async (url) => {
    try {
      let data = await fetch(url);
      let html = await data.text();
      const res = new DOMParser().parseFromString(html, "text/html");
      return { res, status: 200 };
    } catch (e) {
      return { res: e, status: 404 };
    }
  };

  updateProduct = async (handle, dataPlpHandle) => {
    document.body.classList.add(`overflow-hidden`);
    qs(".product-loader")?.classList.remove("hidden");
    let parent = this.parent;
    let data = await this.getHtml(
      `/${
        dataPlpHandle ? `collections/${dataPlpHandle}/` : ""
      }products/${handle}?view=product`
    );
    let parsedHtml = data.res;
    let productTemplateWrapper = qs(".product-template-wrapper", parsedHtml);
    let pageTitle = qs(".product__title .product-title", parsedHtml).innerText;
    document.title = pageTitle;
    window.history.pushState({ pageTitle: pageTitle }, "", handle);
    if (productTemplateWrapper) {
      parent.innerHTML = productTemplateWrapper.innerHTML;
    }
    let productModal = qsa("product-modal.product-media-modal");
    productModal.length > 0 &&
      productModal.forEach((el) => {
        if (el.dataset.handle !== handle) {
          el.remove();
        }
      });
    this.init();
    if ($th_refreshWishlistItems) $th_refreshWishlistItems();
    document.body.classList.remove(`overflow-hidden`);
    qs(".product-loader")?.classList.add("hidden");
  };

  clickEvent = () => {
    this.options?.forEach((option) => {
      option.addEventListener("click", () => {
        let handle = option.dataset.productHandle;
        if (!location.pathname.includes(handle)) {
          this.updateProduct(handle);
        }
      });
    });

    window.addEventListener("popstate", function () {
      location.reload(true);
    });
  };
}

customElements.define("main-product-color", MainProductColor);

function inViewport(element) {
  // Get the elements position relative to the viewport

  var bb = element.getBoundingClientRect();

  // Check if the element is outside the viewport
  // Then invert the returned value because you want to know the opposite

  return !(bb.top > innerHeight || bb.bottom < 450);
}

function productMobileSticky() {
  var element = document.querySelector(".product__info-wrapper"); // Replace 'yourElementId' with the ID of your element
  let btn = document.querySelector(".product-form__buttons");
  if (inViewport(element)) {
    if (btn) {
      btn.classList.remove("fixed");
    }
  } else {
    if (btn) {
      btn.classList.add("fixed");
    }
  }
}
document.addEventListener("DOMContentLoaded", function () {
  if (
    document.querySelector(
      ".product-template-wrapper .product__info-wrapper"
    ) &&
    window.innerWidth <= 767
  ) {
    productMobileSticky();
    window.addEventListener("scroll", () => {
      productMobileSticky();
    });
  }
});

// Functionality to share product
const shareBtnWrapper = document.querySelector(".share-icon-wrapper");
const shareBtn = document.querySelector(".share-icon");
const shareWithBox = document.querySelector(".share-block");
const closeShare = document.querySelector(".close-share");
const wishlistIcon = document.querySelector(".wishlist-icon");

const productUrl = document.getElementById("p_copy_url");
const copyLink = document.querySelector(".copy-product-share-url");
const productContainer = document.querySelector(".product__info-container");
const toaster = document.querySelector(".share-toaster");
const closeCopyToast = document.querySelector(".close-toaster");

/**
 * Opens the share modal
 */
shareBtn.addEventListener("click", () => {
  shareBtnWrapper.classList.add("show");
  productContainer.style.position = "unset";
  wishlistIcon.classList.add("open");
  shareBtnWrapper.classList.add("open");
});

/**
 * Closes the share modal
 */
closeShare.addEventListener("click", () => {
  shareBtnWrapper.classList.remove("show");
  toaster.style.display = "none";
  productContainer.style.position = "sticky";
  wishlistIcon.classList.remove("open");
  shareBtnWrapper.classList.remove("open");
});

function updateToasterText(text) {
  var toastMessage = document.querySelector(".share-toaster .toast-message");
  toaster.style.display = "block";
  toastMessage.textContent = text;

  // Remove the text after 3 seconds (3000 milliseconds)
  setTimeout(function () {
    toastMessage.textContent = "";
    toaster.style.display = "none";
  }, 3000);
}

/**
 * Attaches an event listener to the copy link button
 */
copyLink.addEventListener("click", function () {
  navigator.clipboard.writeText(productUrl.baseURI);
  updateToasterText("Link Copied");
});

closeCopyToast.addEventListener("click", () => {
  toaster.style.display = "none";
});
